import type { CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'

/**
 * Initializes analytics scripts based on remote configuration.
 * If Usercentrics is enabled, loads the Usercentrics CMP script.
 * Otherwise, loads gtag directly without consent management.
 */
export function initializeAnalytics (remoteConfig: CustomerPortalConfig): void {
  const usercentricsEnabled = remoteConfig['analytics.usercentrics.enabled']
  const usercentricsUrl = remoteConfig['analytics.usercentrics.url']
  const usercentricsRulesetId = remoteConfig['analytics.usercentrics.rulesetId']

  if (usercentricsEnabled) {
    if (!usercentricsRulesetId || !usercentricsUrl) return

    const usercentricsScript = document.createElement('script')
    usercentricsScript.id = 'usercentrics-cmp'
    usercentricsScript.src = usercentricsUrl
    usercentricsScript.dataset.rulesetId = usercentricsRulesetId
    usercentricsScript.dataset.language = document.documentElement.lang || 'en'
    usercentricsScript.async = true

    if (!remoteConfig.production) {
      usercentricsScript.dataset.draft = 'true'
    }

    document.head.appendChild(usercentricsScript)
  } else {
    // No consent management - load gtag directly
    const script = document.createElement('script')
    script.src = `https://www.googletagmanager.com/gtag/js?id=${remoteConfig['googleAnalytics.id']}`
    script.async = true
    document.head.prepend(script)
  }
}
